import config from "config"

const normalizeBasename = (value) => {
  const trimmed = (value || "").trim()
  if (!trimmed || trimmed === "/") return ""

  const withLeadingSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`
  return withLeadingSlash.replace(/\/+$/, "")
}

const BASENAME = normalizeBasename(config.basename)

export const getBasename = () => BASENAME

export const withBasename = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`
  return BASENAME ? `${BASENAME}${normalizedPath}` : normalizedPath
}

export const stripBasename = (pathname = "/") => {
  if (!BASENAME) return pathname
  if (pathname === BASENAME) return "/"
  if (pathname.startsWith(`${BASENAME}/`)) {
    return pathname.slice(BASENAME.length)
  }
  return pathname
}
